fragment ContentWithIconsFragment on contentWithIcons_Entry {
  typeHandle
  body
  contentWithIconsCards: cards {
    ... on contentWithIconsCardsBlock_Entry {
      icon {
        url
      }
      heading
      body
    }
  }
}
